import { FileUploader } from "devextreme-react/ui/file-uploader";
import type {
    BeforeSendEvent,
    ProgressEvent,
    UploadAbortedEvent,
    UploadErrorEvent,
    UploadStartedEvent,
    UploadedEvent,
} from "devextreme/ui/file_uploader";
import React from "react";
import { FINISHING_MESSAGE } from "../hooks/useTaskFileUploadController";

type IFileUploaderViewProps = {
    fileUploaderRef: React.RefObject<FileUploader>;
    uploadUrl: string;
    isDisabled: boolean;
    accept?: string;
    allowedFileExtensions?: string[];
    uploadMode?: "instantly" | "useButtons" | "useForm";
    multiple?: boolean;
    chunkSize: number;
    maxFileSize: number;

    onBeforeSend: (e: BeforeSendEvent) => void;
    onUploadStarted: (e: UploadStartedEvent) => void;
    onProgress: (e: ProgressEvent) => void;
    onUploaded: (e: UploadedEvent) => void;
    onUploadError: (e: UploadErrorEvent) => void;
    onUploadAborted: (e: UploadAbortedEvent) => void;
    onValueChange: (files: File[]) => void;
};

export function FileUploaderView({
    fileUploaderRef,
    uploadUrl,
    isDisabled,
    accept,
    allowedFileExtensions,
    uploadMode = "instantly",
    multiple = false,
    chunkSize,
    maxFileSize,
    onBeforeSend,
    onUploadStarted,
    onProgress,
    onUploaded,
    onUploadError,
    onUploadAborted,
    onValueChange,
}: IFileUploaderViewProps) {
    return (
        <FileUploader
            ref={fileUploaderRef}
            name="file"
            accept={accept}
            maxFileSize={maxFileSize}
            uploadUrl={uploadUrl}
            uploadMode={uploadMode}
            multiple={multiple}
            chunkSize={chunkSize}
            uploadedMessage={FINISHING_MESSAGE}
            onBeforeSend={onBeforeSend}
            onUploadStarted={onUploadStarted}
            onProgress={onProgress}
            onUploaded={onUploaded}
            onUploadError={onUploadError}
            onUploadAborted={onUploadAborted}
            onValueChange={onValueChange}
            allowedFileExtensions={allowedFileExtensions}
            disabled={isDisabled}
            visible={!isDisabled}
        />
    );
}
